
    const header=document.querySelector('.site-header');
    const hero=document.querySelector('.hero');
    const kitchenPhoto=document.querySelector('.studio-photo');
    const heroVideo=document.querySelector('.hero-video');
    if(heroVideo){heroVideo.muted=true;heroVideo.play().catch(()=>{});}

    const menuButton=document.querySelector('.menu-button');
    const mobileLinks=document.querySelector('#mobile-links');
    const menuBackdrop=document.querySelector('.menu-backdrop');
    const menuClose=document.querySelector('.menu-close');
    const menuBackground=Array.from(document.querySelectorAll('body > :not(.menu-drawer):not(.menu-backdrop):not(script)'));
    let menuCloseTimer;
    const searchButton=document.querySelector('.search-button');
    const searchPanel=document.querySelector('.search-panel');
    const searchBackdrop=document.querySelector('.search-backdrop');
    const searchInput=document.querySelector('.search-input');
    const searchStatus=document.querySelector('.search-status');
    const searchResults=document.querySelector('.search-results-list');
    const searchEmpty=document.querySelector('.search-empty');
    const currencyButton=document.querySelector('.currency-button');
    const currencyMenu=document.querySelector('.currency-menu');
    const countryList=document.querySelector('.country-list');
    const countrySelector=document.querySelector('.country-selector');
    const headerCurrencySlot=document.querySelector('.header-currency-slot');
    const drawerCurrencySlot=document.querySelector('.drawer-footer');
    const desktopCurrencyMedia=window.matchMedia('(min-width:1000px)');
    let selectedCountry=countryOptions.find(country=>country.code==='US');
    try{selectedCountry=countryOptions.find(country=>country.code===localStorage.getItem('atelier-nappe-country'))||selectedCountry;}catch{}
    let previousFocus;
    const normalize=text=>text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
    const catalog=Array.from(document.querySelectorAll('.product-card'),(card,index)=>{
      card.id='drop-'+String(index+1).padStart(3,'0');
      const title=card.querySelector('h3').textContent;
      const description=card.querySelector('.product-info p').textContent;
      return {card,title,description,keywords:normalize(title+' '+description+' chef pants atelier nappe collection preview coming soon '+String(index+1).padStart(3,'0'))};
    });
    function syncPanelHeader(){header.classList.toggle('panel-open',!searchPanel.hidden);}
    function closeMenu(restoreFocus=false){
      clearTimeout(menuCloseTimer);closeCurrency(false);
      const wasOpen=menuButton.getAttribute('aria-expanded')==='true';
      menuButton.setAttribute('aria-expanded','false');menuButton.setAttribute('aria-label','Open menu');
      menuBackdrop.hidden=true;document.body.classList.remove('menu-open');
      menuBackground.forEach(element=>{element.inert=false;});
      mobileLinks.inert=true;
      if(!mobileLinks.hidden){
        mobileLinks.classList.add('is-closing');
        const delay=window.matchMedia('(prefers-reduced-motion:reduce)').matches?0:300;
        menuCloseTimer=setTimeout(()=>{mobileLinks.hidden=true;mobileLinks.classList.remove('is-closing');},delay);
      }
      syncPanelHeader();if(wasOpen&&restoreFocus)menuButton.focus({preventScroll:true});
    }
    function openMenu(){
      clearTimeout(menuCloseTimer);closeSearch(false);closeCurrency(false);
      mobileLinks.classList.remove('is-closing');mobileLinks.hidden=false;mobileLinks.inert=false;menuBackdrop.hidden=false;
      document.body.classList.add('menu-open');menuButton.setAttribute('aria-expanded','true');menuButton.setAttribute('aria-label','Close menu');
      menuBackground.forEach(element=>{element.inert=true;});syncPanelHeader();menuClose.focus({preventScroll:true});
    }
    const flagFor=code=>flagAssets[code]||flagAssets.US;
    function updateCountry(){
      document.querySelector('.selected-country-flag').src=flagFor(selectedCountry.code);
      document.querySelector('.currency-label').textContent=selectedCountry.currencyCode+' '+selectedCountry.currencySymbol;
      currencyButton.setAttribute('aria-label','Country and currency: '+selectedCountry.name+', '+selectedCountry.currencyCode+' '+selectedCountry.currencySymbol+'. Change country');
      document.body.dataset.country=selectedCountry.code;
      document.body.dataset.currency=selectedCountry.currencyCode;
      countryList.querySelectorAll('.country-option').forEach(option=>{
        const selected=option.dataset.code===selectedCountry.code;
        option.setAttribute('aria-selected',String(selected));
        option.querySelector('.country-check').toggleAttribute('hidden',!selected);
      });
    }
    countryOptions.forEach(country=>{
      const option=document.createElement('button');
      option.type='button';option.className='country-option';option.dataset.code=country.code;
      option.id='country-'+country.code;option.setAttribute('role','option');option.tabIndex=-1;
      const flag=document.createElement('img');flag.className='country-flag';flag.src=flagFor(country.code);flag.alt='';flag.width=20;flag.height=15;flag.loading='lazy';flag.setAttribute('aria-hidden','true');
      const label=document.createElement('span');label.textContent=country.name+' ('+country.currencyCode+' '+country.currencySymbol+')';
      const check=document.createElementNS('http://www.w3.org/2000/svg','svg');check.classList.add('country-check');check.setAttribute('viewBox','0 0 12 12');check.setAttribute('aria-hidden','true');const checkPath=document.createElementNS('http://www.w3.org/2000/svg','path');checkPath.setAttribute('d','m1 6 3 3 7-7');check.append(checkPath);
      option.append(flag,label,check);countryList.append(option);
      option.addEventListener('click',()=>{
        selectedCountry=country;updateCountry();
        try{localStorage.setItem('atelier-nappe-country',country.code);}catch{}
        closeCurrency();
      });
    });
    updateCountry();
    function placeCurrencySelector(){
      const currencyHadFocus=countrySelector.contains(document.activeElement);
      const desktop=desktopCurrencyMedia.matches;
      const destination=desktop?headerCurrencySlot:drawerCurrencySlot;
      drawerCurrencySlot.hidden=desktop;
      if(countrySelector.parentElement===destination)return;
      closeCurrency(false);
      if(menuButton.getAttribute('aria-expanded')==='true')closeMenu(true);
      destination.append(countrySelector);
      if(currencyHadFocus)(desktop?currencyButton:menuButton).focus({preventScroll:true});
    }
    desktopCurrencyMedia.addEventListener('change',placeCurrencySelector);
    placeCurrencySelector();
    function closeCurrency(restoreFocus=true){
      const wasOpen=!currencyMenu.hidden;
      currencyMenu.hidden=true;currencyButton.setAttribute('aria-expanded','false');syncPanelHeader();
      if(wasOpen&&restoreFocus)currencyButton.focus({preventScroll:true});
    }
    function openCurrency(){
      closeSearch(false);currencyMenu.hidden=false;
      currencyButton.setAttribute('aria-expanded','true');syncPanelHeader();
      const selected=countryList.querySelector('[aria-selected="true"]');
      selected.focus({preventScroll:true});selected.scrollIntoView({block:'nearest'});
    }
    currencyButton.addEventListener('click',()=>currencyMenu.hidden?openCurrency():closeCurrency());
    currencyButton.addEventListener('keydown',event=>{
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();openCurrency();}
    });
    let countryTypeahead='',countryTypeaheadTime=0;
    countryList.addEventListener('keydown',event=>{
      const options=Array.from(countryList.querySelectorAll('.country-option'));
      const current=options.indexOf(document.activeElement);
      let target;
      if(event.key==='ArrowDown')target=options[(current+1)%options.length];
      else if(event.key==='ArrowUp')target=options[(current-1+options.length)%options.length];
      else if(event.key==='Home')target=options[0];
      else if(event.key==='End')target=options[options.length-1];
      else if(event.key==='Tab'){closeCurrency();return;}
      else if(event.key.length===1&&!event.altKey&&!event.ctrlKey&&!event.metaKey&&event.key!==' '){
        const now=Date.now();countryTypeahead=now-countryTypeaheadTime>700?'':countryTypeahead;countryTypeaheadTime=now;
        countryTypeahead+=normalize(event.key);
        const query=Array.from(countryTypeahead).every(letter=>letter===countryTypeahead[0])?countryTypeahead[0]:countryTypeahead;
        target=options.slice(current+1).concat(options.slice(0,current+1)).find(option=>normalize(option.textContent).startsWith(query)||normalize(countryOptions.find(country=>country.code===option.dataset.code).name).startsWith(query));
      }
      if(target){event.preventDefault();target.focus({preventScroll:true});target.scrollIntoView({block:'nearest'});}
    });
    document.addEventListener('pointerdown',event=>{if(!currencyMenu.hidden&&!countrySelector.contains(event.target))closeCurrency(false);});
    function renderSearch(){
      const query=normalize(searchInput.value);
      const matches=catalog.filter(item=>!query||query.split(/\s+/).every(word=>item.keywords.includes(word)));
      searchResults.replaceChildren();
      if(!catalog.length){
        searchStatus.textContent='Explore the first collection';searchEmpty.hidden=true;
        const li=document.createElement('li');const link=document.createElement('a');
        link.className='search-result';link.href=(window.Shopify?.routes?.root||'/')+'#collection';
        link.textContent='View the first collection';li.append(link);searchResults.append(li);return;
      }
      searchStatus.textContent=query?matches.length+' '+(matches.length===1?'result':'results'):'Explore the first collection';
      searchEmpty.hidden=matches.length>0;
      matches.forEach(item=>{
        const li=document.createElement('li');
        const link=document.createElement('a');link.className='search-result';link.href='#'+item.card.id;
        const copy=document.createElement('span');
        const title=document.createElement('span');title.className='search-result-title';title.textContent=item.title;
        const detail=document.createElement('small');detail.textContent=item.description;
        const arrow=document.createElement('span');arrow.textContent='↗';arrow.setAttribute('aria-hidden','true');
        copy.append(title,detail);link.append(copy,arrow);li.append(link);searchResults.append(li);
        link.addEventListener('click',()=>{closeSearch(false);requestAnimationFrame(()=>item.card.scrollIntoView({behavior:'smooth',block:'center',inline:'center'}));});
      });
    }
    function openSearch(){
      previousFocus=document.activeElement;closeCurrency(false);closeMenu();
      searchPanel.hidden=false;searchBackdrop.hidden=false;document.body.classList.add('search-open');
      searchButton.setAttribute('aria-expanded','true');syncPanelHeader();renderSearch();searchInput.focus({preventScroll:true});
    }
    function closeSearch(restoreFocus=true){
      searchPanel.hidden=true;searchBackdrop.hidden=true;document.body.classList.remove('search-open');
      searchButton.setAttribute('aria-expanded','false');syncPanelHeader();
      if(restoreFocus&&previousFocus&&previousFocus.isConnected)previousFocus.focus({preventScroll:true});
    }
    menuButton.addEventListener('click',()=>menuButton.getAttribute('aria-expanded')==='true'?closeMenu(true):openMenu());
    menuClose.addEventListener('click',()=>closeMenu(true));
    menuBackdrop.addEventListener('click',()=>closeMenu(true));
    document.querySelector('.drawer-links').addEventListener('click',event=>{if(event.target.closest('a'))closeMenu();});
    document.addEventListener('keydown',event=>{
      if(event.key!=='Tab'||menuButton.getAttribute('aria-expanded')!=='true')return;
      const focusable=Array.from(mobileLinks.querySelectorAll('button,a[href]')).filter(element=>!element.closest('[hidden]'));
      const first=focusable[0],last=focusable[focusable.length-1];
      if(!mobileLinks.contains(document.activeElement)){event.preventDefault();(event.shiftKey?last:first).focus();return;}
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    searchButton.addEventListener('click',()=>searchPanel.hidden?openSearch():closeSearch());
    document.querySelector('.search-close').addEventListener('click',()=>closeSearch());
    searchBackdrop.addEventListener('click',()=>closeSearch());
    searchInput.addEventListener('input',renderSearch);
    document.querySelector('.search-form').addEventListener('submit',event=>{event.preventDefault();renderSearch();});
    searchPanel.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const focusable=Array.from(searchPanel.querySelectorAll('input,button,a[href]'));
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'){if(!currencyMenu.hidden)closeCurrency();else if(!searchPanel.hidden)closeSearch();else if(menuButton.getAttribute('aria-expanded')==='true')closeMenu(true);}});
    let scrollQueued=false;
    function updateHeader(){
      const compactHeight=window.matchMedia('(max-width:720px)').matches?76:88;
      document.body.classList.toggle('header-compact',window.scrollY>96);
      header.classList.toggle('over-content',!hero||window.scrollY>=hero.offsetHeight-compactHeight);
      const photoBounds=kitchenPhoto?kitchenPhoto.getBoundingClientRect():{top:Infinity,bottom:0};
      header.classList.toggle('over-photo',photoBounds.top<=compactHeight/2&&photoBounds.bottom>compactHeight/2);
      scrollQueued=false;
    }
    window.addEventListener('scroll',()=>{if(!scrollQueued){scrollQueued=true;requestAnimationFrame(updateHeader);}},{passive:true});
    window.addEventListener('resize',updateHeader);updateHeader();
    document.querySelector('#year').textContent=String(new Date().getFullYear());
  